import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';
import { selectDatesAvailable } from '../../store/selectors';
import { updateDateRange } from '../../store/updateDateRange';
import { trackEvent } from '../../lib/Tracking';
import { DataRange, ReduxState } from '../../types';

type Props = {
  children: React.ReactNode;
  updateDateRange: typeof updateDateRange;
  datesAvailable: DataRange;
};

export class Network extends PureComponent<Props> {
  UNSAFE_componentWillMount() {
    const endDate = this.props.datesAvailable.until;
    this.props.updateDateRange(
      moment(endDate)
        .subtract(6, 'days')
        .format('YYYY-MM-DD'),
      moment(endDate).format('YYYY-MM-DD'),
      'Last 7 days',
    );
  }

  componentDidMount() {
    trackEvent({ category: 'page-type', action: 'view', label: 'network' });
  }

  render() {
    return this.props.children;
  }
}

const selector = createStructuredSelector<
  ReduxState,
  {
    datesAvailable: ReturnType<typeof selectDatesAvailable>;
  }
>({
  datesAvailable: selectDatesAvailable,
});

const actions = { updateDateRange };

export const ConnectedNetwork = connect(selector, actions)(Network);
